import { Col, Row, Tabs, TabsProps } from "antd";
import { NeedHelp } from "../../atoms/CustomIcons";
import DashboardTemplate from "../../templates/Dashboard";
import DashboardHeader from "./Components/DashboardHeader";
import RightSideBar from "./Components/RightSideBar";
import TabScopePricing from "./Components/DashboardTabs/TabScopePricing";
import TabWorkOrders from "./Components/DashboardTabs/TabWorkOrders";
import TabMaterials from "./Components/DashboardTabs/TabMaterials";
import DashboardTab from "./Components/DashboardTabs/TabDashboard";

export default function Dashboard() {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Dashboard",
      children: <DashboardTab />,
    },
    {
      key: "2",
      label: "Scope & pricing",
      children: <TabScopePricing />,
    },
    {
      key: "3",
      label: "Work orders",
      children: <TabWorkOrders />,
    },
    {
      key: "4",
      label: "Materials",
      children: <TabMaterials />,
    },
  ];

  return (
    <DashboardTemplate loading={false}>
      <DashboardHeader
        breadcrumb={[
          { label: "Potential deals", href: `` },
          { label: "Maintenance Standard - Warm Season" },
        ]}
        title="Maintenance standard - warm season"
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
        propertyName="Sapphire Springs Villas"
        propertyClientName="Land-top company"
      />

      <div className="dashboard_wrapper">
        <Row gutter={16} wrap={false}>
          <Col span={18} className="left_area">
            <div className="tabsBox">
              <Tabs
                defaultActiveKey="1"
                items={items}
                className="dashboard_tabs"
              />
            </div>
          </Col>
          <Col span={6} className="right_area">
            <RightSideBar />
          </Col>
        </Row>
      </div>
    </DashboardTemplate>
  );
}
